import styles from './Logs.module.scss'
import api from '../../api'
import React, { useEffect, useState } from 'react'
import TableColTitle from 'components/TableColTitle/TableColTitle'
import dayjs from 'dayjs'
import style from '../Makes/Makes.module.scss'
import styleExp from '../Exceptions/Exceptions.module.scss'
import Select from 'components/Select/Select'
import Input from 'components/Input/Input'
import searchIcon from '../../assets/img/searchColored.svg'
import Modal from '../../components/Modal/Modal'
import Button from '../../components/Button/Button'
// import Pagination from "../../components/Pagination/Pagination";

type OrderBy = { value: keyof WorkerTask; reverse: boolean }

const CarLogs = () => {
  // @ts-ignore
  const { data: dates, isFetching: datesIsLoading } = api.useGetLogDatesQuery()
  const [date, setDate] = useState<number | undefined>(undefined)
  const [filterName, setFilterName] = useState<string | undefined>()
  const [orderBy, setOrderBy] = useState<OrderBy | undefined>({ value: 'id', reverse: true })
  const { data, error, isLoading } = api.useGetCarLogsQuery({
    date: date,
    car_id: filterName,
    order_by: orderBy ? (orderBy.reverse ? '-' : '') + orderBy.value : undefined,
  })

  const [selectedException, setSelectedException] = useState<any | undefined>()
  const onExceptionClick = (e: any) => {
    setSelectedException(e)
  }
  const renderObject = (obj, prefix = '') => {
    return Object.keys(obj).map((key) => {
      const value = obj[key]
      const newKey = prefix ? `${key}` : key

      if (typeof value === 'object' && value !== null) {
        return (
          <div key={newKey}>
            <h3>Failed step: {parseInt(newKey) + 1}</h3>
            <div style={{ paddingLeft: '20px' }}>{renderObject(value, newKey)}</div>
          </div>
        )
      } else {
        return (
          <div key={newKey}>
            <strong>{newKey}:</strong> {value ? value.toString() : 'null'}
          </div>
        )
      }
    })
  }
  const onChangeOrderBy = (value) => {
    // @ts-ignore
    setOrderBy((v) => {
      if (v?.reverse && v.value === value) return undefined
      else {
        const reverse = v?.value === value
        return {
          value,
          reverse,
        }
      }
    })
  }

  useEffect(() => {
    if (dates !== undefined && dates.length > 0) setDate(dates[0])
  }, [dates])

  if (isLoading) return <div>Loading...</div>
  if (error) return <div>Error fetching logs</div>
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Feed processing logs</h1>
      </div>

      {selectedException && (
        <Modal onCloseModal={() => setSelectedException(undefined)}>
          <div className={styles.logModal}>
            <h2 className={styles.logModalTitle}>Record details</h2>
            <div>
              {/*<h3>Steps:</h3>*/}
              {renderObject(JSON.parse(selectedException.message))}
            </div>
            <div className={styles.vehicle}>
              <h3>Vehicle info:</h3>
              {renderObject(selectedException.vehicle)}
            </div>
            <div className={styles.additional_info}>
              <h3>Additional Info:</h3>
              {renderObject(selectedException.additional_info)}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={() => setSelectedException(false)} type={'button'} className={styles.closeBtn}>
                Close
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div className={style.filters}>
        <h4>Filters:</h4>
        <Input size={'small'} label={'Car ID'} value={filterName} onChange={setFilterName} />
        <label style={{ marginLeft: '15px' }}>Date:</label>
        <Select
          placeholder={'All'}
          value={date ? { id: date, label: dayjs(date * 1000).format('lll') } : undefined}
          options={dates?.map((d) => ({ id: d, label: dayjs(d * 1000).format('lll') }))}
          onChange={(v) => setDate(v ? Number(v.id) : undefined)}
          clearable
          btnClassName={styleExp.dateSelectBtn}
        />
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>
                <TableColTitle label={'Car ID'} name={'vin'} />
              </th>
              <th>
                <TableColTitle label={'Make'} name={'make'} />
              </th>
              <th>
                <TableColTitle label={'Model'} name={'model'} />
              </th>
              <th>
                <TableColTitle label={'Service'} name={'stage'} />
              </th>
              <th onClick={() => onChangeOrderBy('result')}>
                <TableColTitle label={'Result'} name={'result'} sorted={orderBy} />
              </th>
              <th>
                <TableColTitle label={'Timestamp'} name={'timestamp'} />
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((log) => (
              <tr key={log._id}>
                <td>{log.car_id ? log.car_id : log.car_uuid}</td>
                <td>{log.vehicle.make}</td>
                <td>{log.vehicle.model}</td>
                <td>{log.service ? log.service : '-'}</td>
                <td>{log.result}</td>
                <td>{log.timestamp ? dayjs(log.timestamp).format('lll') : '-'}</td>
                {log.result === 'error' ? (
                  <td>
                    <div style={{ display: 'flex' }}>
                      <button
                        className={styles.fixBtn}
                        onClick={() => onExceptionClick(log)}
                        title={'Fix'}
                        style={{ marginRight: 10 }}>
                        <img src={searchIcon} alt={'Fix'} />
                      </button>
                    </div>
                  </td>
                ) : (
                  <td></td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/*{tasks && (*/}
      {/*    <Pagination*/}
      {/*        pageCount={tasks.pagination.count}*/}
      {/*        curPage={page + 1}*/}
      {/*        onChange={(p: number) => setPage(p - 1)}*/}
      {/*        className={styles.pagination}*/}
      {/*    />*/}
      {/*)}*/}
    </div>
  )
}

export default CarLogs
